import { Container } from "@mui/material";

import ExperiencesContainer from "@/components/ExperiencesContainer";
import MerchContainer from "@/components/MerchContainer";

import BottomTabs from "@/components/BottomTabs";
import MainAppBar from "@/components/MainAppBar";
import SideTabs from "@/components/SideTabs";

import { useParams } from "react-router-dom";
import { SubscribedProvider } from "@/providers/Subscribed";
export default function Store() {
  const { artistKey } = useParams();

  return (
    <SubscribedProvider artistKey={artistKey}>
      <Container maxWidth="sm" disableGutters>
        <MainAppBar />

        <MerchContainer artistKey={artistKey} />
        <ExperiencesContainer artistKey={artistKey} />

        <BottomTabs />
        <SideTabs />
      </Container>
    </SubscribedProvider>
  );
}
